/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListUserCompaniesParams,
  SchemaValidationErrorResponse,
  UserCompaniesCollection,
  UserContentLocalesInput,
  UserUnion,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * Companies the current user can access for the requested eligibility context. Shared feature modes apply their group opt-out; timetable requires current Tools access.
 * @summary List companies the current user can currently access
 */
export const listUserCompanies = (
    params?: MaybeRefOrGetter<ListUserCompaniesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<UserCompaniesCollection>(
      {url: `/users/companies`, method: 'GET',
        params, signal
    },
      );
    }




export const getListUserCompaniesQueryKey = (params?: MaybeRefOrGetter<ListUserCompaniesParams>,) => {
    return [
    'users','companies', ...(params ? [params] : [])
    ] as const;
    }


export const getListUserCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof listUserCompanies>>, TError = ErrorType<void>>(params?: MaybeRefOrGetter<ListUserCompaniesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserCompanies>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListUserCompaniesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUserCompanies>>> = ({ signal }) => listUserCompanies(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUserCompanies>>, TError, TData>
}

export type ListUserCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof listUserCompanies>>>
export type ListUserCompaniesQueryError = ErrorType<void>


/**
 * @summary List companies the current user can currently access
 */

export function useListUserCompanies<TData = Awaited<ReturnType<typeof listUserCompanies>>, TError = ErrorType<void>>(
 params?: MaybeRefOrGetter<ListUserCompaniesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserCompanies>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUserCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Current User Details
 */
export const getMe = (

 signal?: AbortSignal
) => {


      return axiosClient<UserUnion>(
      {url: `/users/me`, method: 'GET', signal
    },
      );
    }




export const getGetMeQueryKey = () => {
    return [
    'users','me'
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<unknown>


/**
 * @summary Current User Details
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Saves the languages picked in the course catalog's or the gallery's language filter. They become the default content languages (`defaultContentLocales`) for the catalog, the course lists, recommendations and the gallery.
 * @summary Save the current user's content languages
 */
export const updateUserContentLocales = (
    userContentLocalesInput: MaybeRefOrGetter<UserContentLocalesInput>,
 signal?: AbortSignal
) => {
      userContentLocalesInput = toValue(userContentLocalesInput);

      return axiosClient<void>(
      {url: `/users/me/content_locales`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userContentLocalesInput, signal
    },
      );
    }




export const getUpdateUserContentLocalesMutationKey = () => ['updateUserContentLocales'] as const;

export const getUpdateUserContentLocalesMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserContentLocales>>, TError,UpdateUserContentLocalesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateUserContentLocales>>, TError,UpdateUserContentLocalesMutationVariables, TContext> => {

const mutationKey = getUpdateUserContentLocalesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserContentLocales>>, UpdateUserContentLocalesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateUserContentLocales(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserContentLocalesMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserContentLocales>>>
    export type UpdateUserContentLocalesMutationBody = UserContentLocalesInput
    export type UpdateUserContentLocalesMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type UpdateUserContentLocalesMutationVariables = {data: UserContentLocalesInput}

    /**
 * @summary Save the current user's content languages
 */
export const useUpdateUserContentLocales = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserContentLocales>>, TError,UpdateUserContentLocalesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateUserContentLocales>>,
        TError,
        UpdateUserContentLocalesMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateUserContentLocalesMutationOptions(options), queryClient);
    }
